var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, PageLayout, Spinner, compose, useShowFlag, withFeatureFlag, } from "@atlassiansox/microscopekit";
import React, { useState } from "react";
import styled from "styled-components"; // tslint:disable-line
import { useIsServiceAdmin, usePanels } from "../hooks";
import { withPanelsMigrationBanner } from "../utils";
import { PanelList } from "./panel-list";
import { SearchModal } from "./search-modal";
var PanelListWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 20px;\n"], ["\n  padding-top: 20px;\n"])));
export var PanelsManagerView = function (props) {
    var showFlag = useShowFlag();
    var _a = usePanels(props.id), service = _a.service, panels = _a.panels, error = _a.error, loading = _a.loading, refetch = _a.refetch;
    var isAdmin = useIsServiceAdmin(props.id);
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var closeModal = function () { return setIsOpen(false); };
    var openModal = function () { return setIsOpen(true); };
    if (loading) {
        return React.createElement(Spinner, null);
    }
    if (error) {
        return (React.createElement(PageLayout, { title: "Installed Panels" },
            React.createElement("p", null, "Sorry we couldn't load the list of installed panels. Please try refreshing the page")));
    }
    if (!service) {
        return (React.createElement(PageLayout, { title: "Installed Panels" },
            React.createElement("p", null,
                "Service ",
                props.id,
                " is not found")));
    }
    if (service.metadata.platform !== "micros") {
        return (React.createElement(PageLayout, { title: "Installed Panels" },
            React.createElement("p", null,
                props.id,
                " is not a Micros service")));
    }
    return (React.createElement(PageLayout, __assign({ title: "Installed Panels" }, (isAdmin
        ? {
            actions: (React.createElement(Button, { appearance: "primary", onClick: openModal }, "Install New Panel")),
        }
        : {})),
        !loading && !panels.length && (React.createElement("p", null, "This service doesn't have any panels installed yet.")),
        React.createElement(PanelListWrapper, null, !!panels.length && (React.createElement(PanelList, { serviceId: props.id, onUninstallSuccess: function (panelName) {
                refetch();
                showFlag({
                    title: "Uninstalled Panel successfully",
                    message: "Panel " + panelName + " is uninstalled",
                    type: "success",
                });
            }, onUninstallFailure: function (panelName, e) {
                showFlag({
                    title: "Failed to uninstall Panel " + panelName,
                    message: e.message,
                    type: "error",
                });
            }, panels: panels }))),
        isAdmin && (React.createElement(SearchModal, { serviceId: props.id, isOpen: isOpen, onClose: closeModal }))));
};
export var PanelsManager = compose(withFeatureFlag("panelsPlugin"), withPanelsMigrationBanner)(PanelsManagerView);
var templateObject_1;
